import { Carousel } from './Carousel';
import { Info } from './Info';
import { Wrapper } from './Timeline.styles';

import { LoadingCircleSpinner } from '@/components/Loaders';
import { usePlanificationTimeline } from '@/hooks/usePlanificationTimeline';

export const Timeline = () => {
  const {
    selectedDate,
    isLoading,
    planificationDates,
    carouselRef,
    handleDateClick,
    setCurrentSlide,
    hasPlanification
  } = usePlanificationTimeline();

  if (isLoading) {
    return (
      <Wrapper vertical gap={28} justify="center" align="center">
        <LoadingCircleSpinner />
      </Wrapper>
    );
  }

  if (!hasPlanification || planificationDates.length === 0) {
    return null;
  }

  return (
    <Wrapper vertical gap={28}>
      <Info />
      <div>
        <Carousel
          carouselRef={carouselRef}
          setCurrentSlide={setCurrentSlide}
          planificationDates={planificationDates}
          selectedDate={selectedDate}
          onDateClick={handleDateClick}
        />
      </div>
    </Wrapper>
  );
};
